import React from 'react';
import UserAdmin from './UserAdmin';

const AccessScopeAdmin: React.FC = () => {
  return <UserAdmin mode="access" />;
};

export default AccessScopeAdmin;
